import styled from 'styled-components'

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 50px;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#f9f9f9')};
`

export const NotFoundImg = styled.img`
  height: 200px;
  width: 200px;
  margin-bottom: 10px;
`

export const NotFoundTitle = styled.h1`
  font-size: 40px;
  text-align: center;
  margin-bottom: 10px;
  font-family: 'Roboto';
  font-weight: bold;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#181818')};
`
export const NotFoundPara = styled.p`
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
  font-family: 'Roboto';
  color: ${props => (props.theme === true ? '#7e858e' : '#606060')};
`
